import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { differenceInSeconds } from 'date-fns';
import getUserId from 'utils/session/getUserId';
import { useFetchUserSkills } from 'actions/users';
import Box from 'components/Box';
import Card from 'components/Card';
import EmptyStateController from 'components/EmptyStateController';
import Flag from 'components/Flag';
import FriendlyDuration from 'components/FriendlyDuration';
import Heading from 'components/Heading';
import IconDisc from 'components/IconDisc';
import InlineList from 'components/InlineList';
import Stack from 'components/Stack';
import UserGeneratedText from 'components/UserGeneratedText';
function UserSkillsWidget(_ref) {
  var userId = _ref.userId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchUserSkills = useFetchUserSkills({
      userId: userId
    }),
    items = _useFetchUserSkills.items,
    isLoading = _useFetchUserSkills.isLoading,
    isError = _useFetchUserSkills.isError;
  var isCurrentUser = Number(userId) === Number(getUserId()) || !userId;
  return /*#__PURE__*/React.createElement(EmptyStateController, {
    isLoading: isLoading,
    isError: isError,
    isEmpty: items.length === 0,
    emptyContent: /*#__PURE__*/React.createElement("p", null, t(isCurrentUser ? 'You have not participated in any meetings with skill tracking yet.' : 'This person has not participated in any meetings with skill tracking yet.'))
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "l",
    maxWidth: 860
  }, items.map(function (meeting) {
    var startTime = new Date(meeting.startTime);
    var formattedDate = startTime.toLocaleDateString('en-GB', {
      dateStyle: 'medium'
    });
    var formattedTime = startTime.toLocaleTimeString('en-GB', {
      timeStyle: 'short',
      hour12: true
    });
    var duration = differenceInSeconds(new Date(meeting.endTime), new Date(meeting.startTime));
    return /*#__PURE__*/React.createElement(Flag, {
      key: meeting.title,
      token: /*#__PURE__*/React.createElement(IconDisc, {
        size: "big",
        shady: true,
        name: "asset-activity"
      }),
      align: "top"
    }, /*#__PURE__*/React.createElement(Card, {
      px: "m",
      py: "s"
    }, /*#__PURE__*/React.createElement(Heading, {
      as: "h2"
    }, meeting.title), /*#__PURE__*/React.createElement(Box, {
      dimmed: true,
      fontSize: "s",
      mt: "xxs",
      mb: "s"
    }, /*#__PURE__*/React.createElement(InlineList, {
      splitBy: "dot",
      as: "p",
      itemAs: "span",
      display: "inline"
    }, formattedDate, formattedTime, /*#__PURE__*/React.createElement(FriendlyDuration, {
      value: duration
    }), /*#__PURE__*/React.createElement(React.Fragment, null, t('Organised by'), ' ', meeting.organiserEmail), meeting.meetingPlatform)), /*#__PURE__*/React.createElement(UserGeneratedText, {
      text: meeting.analysis
    })));
  })));
}
export default UserSkillsWidget;